import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { FormHelperText, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../../../components/Common/AppDialog";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import Label from "../../../../components/Common/Label";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import Notification from "../../../../components/Common/Notification";
import SearchBar from "../../../../components/Common/Searchbar";
import Table from "../../../../components/Common/Table";
import TablePageControl from "../../../../components/Common/TablePageControl";
import CustomButton from "../../../../components/Form/CustomButton";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../../components/Form/CustomSelect2";
import CustomTextField from "../../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../../components/Form/RadioButtonGroup";
import Helpers from "../../../../helpers/helpers";
import { createManufacturer, deleteManufacturer, exportManufacturer, getGeneral, getManufacturerListing, resetManufacturerAttachmentState, resetManufacturerState, updateManufacturer } from "../../../../store/actions";
import "../../setting.css";
import RenderPopOverButton from "../../../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../../../components/Common/DeleteModal.js";


const ProductManufacturerSetting = ({ manufacturerListing, formError, editManufacturer, addManufacturer, deleteManufacturerItem, exportManufacturerDocument, userPermission }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");
    const [values, setFormValues] = useState({ status: '' });
    const [selectedRow, setSelectedRow] = useState();
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState();
    const [error, setError] = useState();
    const searchRef = useRef(keyword);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const data = [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        dispatch(resetManufacturerState());
    }, [])

    useEffect(() => {
        if (formError?.length > 0) {
            setError(formError[0]);
            setIsLoading(false);
        }
    }, [formError])

    useEffect(() => {
        if (exportManufacturerDocument?.code === 'success' && exportManufacturerDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(exportManufacturerDocument.excel_base64, 'manufacturer_listing');
            dispatch(resetManufacturerAttachmentState());
        }
        setIsLoading(false);
    }, [exportManufacturerDocument])

    useEffect(() => {
        if (addManufacturer?.code === 'success') {
            setNotification({
                open: true,
                msg: "Manufacturer added successfully",
                type: "success",
            })
            resetFormValues();
            setAddModalOpen(false);
            setIsLoading(false);
            dispatch(getGeneral());
            dispatch(resetManufacturerState());
            initData();
        }

    }, [addManufacturer])

    useEffect(() => {
        if (editManufacturer?.code === 'success') {
            setNotification({
                open: true,
                msg: "Manufacturer updated successfully",
                type: "success",
            })
            setSelectedRow(null);
            setEditModalOpen(false);
            setIsLoading(false);
            dispatch(getGeneral());
            dispatch(resetManufacturerState());
            initData();
        }

    }, [editManufacturer])

    useEffect(() => {
        if (deleteManufacturerItem?.code === "success") {
            setDeleteOpen(false);
            setNotification({ open: true, msg: "Manufacturer deleted successfully", type: "success" });
            dispatch(resetManufacturerState());
            dispatch(getGeneral());
            setPage('1');
            initData();
        }
        setIsLoading(false);
    }, [deleteManufacturerItem])

    useEffect(() => {
        initData();
    }, [page, length, sort, sort_by, filterStatus])

    const header = [
        {
            Header: "Manufacturer name",
            columnID: "id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps?.name || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Description",
            columnID: "descriptions",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.descriptions || '-'}</React.Fragment>)
            },
            minWidth: 250,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel label={cellProps?.status === 1 ? 'active' : 'inactive'} marginLeft={"0px"} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <CustomIconButton
                            iconName={'ri-pencil-line'}
                            onClick={() => { setError(); setSelectedRow(cellProps); setEditModalOpen(true) }}
                        />}
                        <RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#ED1A3D',
                                permission: deletable,
                                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                            }]}
                        />
                    </React.Fragment>
                )
            },
            position: 'sticky',
            disableFilters: true,
            filterable: false,
            minWidth: 120
        }
    ]

    const initData = () => {
        let paylaod = {
            paginate: page,
            sort_order: sort,
            size: length,
            search: searchRef.current,
            filterStatus: filterStatus === 'all' ? '' : filterStatus,
            sort: sort_by,
        }
        dispatch(getManufacturerListing(paylaod));
    }

    const handleNewManufacturer = () => {
        setIsLoading(true);
        let payload = {
            name: values?.name,
            descriptions: values?.decs,
        }
        dispatch(createManufacturer(payload));
    }

    const handleEditManufacturer = () => {
        setIsLoading(true);
        let payload = {
            name: selectedRow?.name,
            descriptions: selectedRow?.descriptions,
            status: selectedRow?.status,
        }
        dispatch(updateManufacturer({ id: selectedRow.id, data: payload }));
    }

    const handleDelete = () => {
        if (selectedRow?.id) {
            setIsLoading(true);
            dispatch(deleteManufacturer({ id: selectedRow.id }));
        }
    }

    const handleExport = () => {
        let filter = {
            status: filterStatus,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportManufacturer({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus(filterStatus === '' ? 'all' : '');
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const resetFormValues = () => {
        setFormValues({
            status: '',
            name: '',
            decs: '',
        });
    }
    const addManufacturerModal = () => {
        return (
            <AppDialog
                titleIcon={'add'}
                title={'Add Manufacturer'}
                open={addModalOpen}
                close={() => { setError(); setAddModalOpen(false) }}
                positiveTitle={'Save'}
                positivePress={() => handleNewManufacturer()}
                negativeTitle={'Cancel'}
                negativePress={() => setAddModalOpen(false)}
                width={'40%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Manufacturer name'}
                            values={values?.name}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                name: e
                            }))}
                            placeholder="e.g Lenovo"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomTextField
                            title={'Description (Optional)'}
                            values={values?.decs}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                decs: e
                            }))}
                            multiline={true}
                            rows={4}
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.decs || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const editManufacturerModal = () => {
        return (
            <AppDialog
                titleIcon={'edit'}
                title={'Edit Manufacturer'}
                open={editModalOpen}
                close={() => setEditModalOpen(false)}
                positiveTitle={'Save Changes'}
                positivePress={() => handleEditManufacturer()}
                negativeTitle={'Cancel'}
                negativePress={() => setEditModalOpen(false)}
                width={'40%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Manufacturer name'}
                            values={selectedRow?.name}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                name: e
                            }))}
                            placeholder="Manufacturer name"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomTextField
                            title={'Description (Optional)'}
                            values={selectedRow?.descriptions}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                descriptions: e
                            }))}
                            multiline={true}
                            rows={4}
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.descriptions || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <RadioButtonGroup
                            title={'Status'}
                            value={`${selectedRow?.status}` || ''}
                            data={data}
                            setValue={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                status: e,
                            }))}
                            required="true"
                            name="status"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={12} md={10} lg={10} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3} md={3} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12}>
                        <CustomSelect2
                            values={filterStatus || "all"}
                            onChange={(e) => { setPage("1"); setFilterStatus(e || '') }}
                            data={Helpers.status}
                            placeholder={"All statuses"}
                        />
                    </Grid>
                    <Grid item lg={5} md={5} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item xs={12} sm={12} md={2} lg={2} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !manufacturerListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: "Manufacturers", link: "#" },
                        ]}
                    >
                        {creatable && <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Manufacturer</>}
                            press={() => setAddModalOpen(true)}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />}
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={manufacturerListing?.data || []}
                        pageSize={length}
                        totalPage={manufacturerListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={manufacturerListing?.last_page || 1}
                    />
                    {addManufacturerModal()}
                    {editManufacturerModal()}
                    <DeleteModal
                        open={deleteOpen}
                        close={() => setDeleteOpen(false)}
                        submit={() => handleDelete()}
                        module={'manufacturer'}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Manufacturer, Login }) {
    return {
        manufacturerListing: Manufacturer.manufacturerListing.data,
        addManufacturer: Manufacturer.addManufacturer,
        editManufacturer: Manufacturer.updateManufacturer,
        deleteManufacturerItem: Manufacturer.deleteManufacturer,
        exportManufacturerDocument: Manufacturer.exportManufacturer,
        formError: Manufacturer.error,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(ProductManufacturerSetting);